import { useEffect, useState } from "react";
import { NamedProperty, getSortedCollection } from "sprint-common-web";

import { GetStorageProfileLookupResponse } from "../../../common/api/orders-api/storage-profiles/GetStorageProfileLookupResponse";
import { useAdminDeliveryEndpointApi } from "../api/useAdminDeliveryEndpointApi";

export const useSigniantStorageEndpoints = () => {
    const { getStorageProfiles } = useAdminDeliveryEndpointApi();
    const [items, setItems] = useState<NamedProperty[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        getStorageProfiles().then((response: GetStorageProfileLookupResponse) => {
            const storageProfiles = response.items.map((storageProfile) => ({
                id: storageProfile.id,
                name: storageProfile.name
            }));
            setItems(getSortedCollection(storageProfiles, "name"));
            setIsLoading(false);
        });
    }, []);

    return {
        storageProfiles: items,
        isLoading
    };
};
